let apidaePrestas = {

    components: {
        apidaePrestasSearch,
        apidaePrestasListe
    },
    props: {
        loading: Boolean,
        loadPaginate: Boolean,
        uri: String,
        title: String,
        layoutMode: String,
        type: String,
        typeFiltre: String,
        typePaginate: String,
        prestaItems: Array,
        lang: String,
        query: String,
        showDate: Number,
        showTarif: Number,
        showCart: Number,
        showMap: Number,
        showFiltre: Number,
        showFiltreResults: Number,
        showFiltreLib: Number,
        showFiltreTri: Number,
        showFiltreGroupes: Number,
        showFiltreDate: Number,
        showFiltreAge: Number,
        showFiltrePrice: Number,
        showFiltreCapacity: Number,
        showFiltreNombreChambres: Number,
        showFiltreNombreJours: Number,
        showFiltreNombreNuits: Number,
        showFiltreDistance: Number,
        showFiltreDuration: Number,
        showFiltreElevation: Number,
        showSearchByGeo: Number,
        triFilters: Array,
        tri: Array,
        params: Object,
        groupesFiltres: Array,
        pmin: Number,
        pmax: Number,
        njmin: Number,
        njmax: Number,
        suggestions: Array,
        searchByGeo: Number,
        searchByGeoRange: Number
    },
    template: `
        <div class="Prestas Prestas--full" :class="typeFiltre">
            <div v-if="loading" class="loading"></div>
            <h2 class="ArticleHeader-h2 h2" v-if="title">{{ title }}</h2>
            <apidae-prestas-search v-if="showFiltre && !loading" :params="params" :groupes-filtres="groupesFiltres" :pmin="pmin" :pmax="pmax" :njmin="njmin" :njmax="njmax" :search-by-geo="searchByGeo" :search-by-geo-range="searchByGeoRange" :type="type" :title="title" :lang="lang" :suggestions="suggestions" :show-date="showDate" :show-tarif="showTarif" :show-filtre="showFiltre" :show-filtre-results="showFiltreResults" :show-filtre-lib="showFiltreLib" :show-filtre-groupes="showFiltreGroupes" :show-filtre-age="showFiltreAge" :show-filtre-date="showFiltreDate" :show-filtre-price="showFiltrePrice" :show-filtre-capacity="showFiltreCapacity" :show-filtre-nombre-chambres="showFiltreNombreChambres" :show-filtre-nombre-jours="showFiltreNombreJours" :show-filtre-nombre-nuits="showFiltreNombreNuits" :show-filtre-distance="showFiltreDistance" :show-filtre-duration="showFiltreDuration" :show-filtre-elevation="showFiltreElevation" :show-search-by-geo="showSearchByGeo"  />
            <apidae-prestas-liste v-if="!loading" :load-paginate="loadPaginate" :uri="uri" :presta-items="prestaItems" :lang="lang" :query="query" :tri-filters="triFilters" :tri="tri" :params="params" :layout-mode="layoutMode" :type="type" :type-paginate="typePaginate" :show-date="showDate" :show-tarif="showTarif" :show-cart="showCart" :show-map="showMap" :show-filtre-tri="showFiltreTri" />
        </div>`
};

if (document.querySelector('.prestaItems')) {
    document.querySelectorAll('.prestaItems').forEach(i => {
        let id = i.getAttribute('id');
        let uri = i.dataset.url;
        let title = i.dataset.title;
        let layoutMode = i.dataset.layoutmode;
        let type = i.dataset.type;
        let typeFiltre = i.dataset.typefiltre;
        let typePaginate = i.dataset.typepaginate;
        let nb = i.dataset.nb;
        let lang = i.dataset.lang;
        let showDate = parseInt(i.dataset.showdate);
        let showTarif = parseInt(i.dataset.showtarif);
        let showCart = parseInt(i.dataset.showcart);
        let showMap = parseInt(i.dataset.showmap);
        let showFiltre = parseInt(i.dataset.showfiltre);
        let showFiltreResults = parseInt(i.dataset.showfiltreresults);
        let showFiltreLib = parseInt(i.dataset.showfiltrelib);
        let showFiltreTri = parseInt(i.dataset.showfiltretri);
        let showFiltreGroupes = parseInt(i.dataset.showfiltregroupes);
        let showFiltreDate = parseInt(i.dataset.showfiltredate);
        let showFiltreAge = parseInt(i.dataset.showfiltreage);
        let showFiltrePrice = parseInt(i.dataset.showfiltreprice);
        let showFiltreCapacity = parseInt(i.dataset.showfiltrecapacity);
        let showFiltreNombreChambres = parseInt(i.dataset.showfiltrenombrechambres);
        let showFiltreNombreJours = parseInt(i.dataset.showfiltrenombrejours);
        let showFiltreNombreNuits = parseInt(i.dataset.showfiltrenombrenuits);
        let showFiltreDistance = parseInt(i.dataset.showfiltredistance);
        let showFiltreDuration = parseInt(i.dataset.showfiltreduration);
        let showFiltreElevation = parseInt(i.dataset.showfiltreelevation);
        let showSearchByGeo = parseInt(i.dataset.showsearchbygeo);
        let filter = i.dataset.filter;
        let searchParams = new URLSearchParams(window.location.search);

        new Vue({
        
            el: '#' + id,
            components: {
                apidaePrestas
            },
            data: function() {
                return {
                    zoom: 2,
                    center: [0, 0],
                    rotation: 0,
                    geolocPosition: undefined,
                    loading: true,
                    loadPaginate: false,
                    query: '?' + searchParams.toString(),
                    uri: uri,
                    title: title,
                    nb: nb,
                    layoutMode: layoutMode,
                    type: type,
                    typeFiltre: typeFiltre,
                    typePaginate: typePaginate,
                    prestaItems: [],
                    lang: lang,
                    showDate: showDate,
                    showTarif: showTarif,
                    showCart: showCart,
                    showMap: showMap,
                    showFiltre: showFiltre,
                    showFiltreResults: showFiltreResults,
                    showFiltreLib: showFiltreLib,
                    showFiltreTri: showFiltreTri,
                    showFiltreGroupes: showFiltreGroupes,
                    showFiltreAge: showFiltreAge,
                    showFiltreDate: showFiltreDate,
                    showFiltrePrice: showFiltrePrice,
                    showFiltreCapacity: showFiltreCapacity,
                    showFiltreNombreChambres: showFiltreNombreChambres,
                    showFiltreNombreJours: showFiltreNombreJours,
                    showFiltreNombreNuits: showFiltreNombreNuits,
                    showFiltreDistance: showFiltreDistance,
                    showFiltreDuration: showFiltreDuration,
                    showFiltreElevation: showFiltreElevation,
                    showSearchByGeo: showSearchByGeo,
                    triFilters: [],
                    tri: ["alphabetique"],
                    layout: {},
                    params: {},
                    groupesFiltres: [],
                    pmin: 0,
                    pmax: 10000,
                    njmin: 0,
                    njmax: 1000,
                    lib: '',
                    suggestions: [],
                    searchByGeo: 0,
                    searchByGeoRange: 1000
                }
            },
            mounted: function() {
                fetch(apidae.site_url + this.uri + '/json' + this.query)
                    .then((stream) => stream.json())
                    .then((data) => {
                        this.layout = data.layout;
                        // this.layoutMode = this.layout.layoutMode;
                        this.triFilters = this.layout.triFilters;
                        this.tri = this.layout.tri;
                        this.params = data.params;
                        this.searchByGeo = parseInt(this.params.searchByGeo);
                        this.searchByGeoRange = parseInt(this.params.searchByGeoRange);
                        this.groupesFiltres = data.filtres;
                        this.suggestions = data.items;
                        this.prestaItems = data.items.slice(0, this.nb);
                        // console.log(this.prestaItems);

                        this.loading = false;

                        if (this.type == 'slide' && this.type != 'grid') {
                            imagesLoaded(this, function() {
                                jQuery('#' + id + ' .slider-prestaList').owlCarousel({
                                    loop: false,
                                    margin: 30,
                                    nav: true,
                                    dots: false,
                                    navText: ['<i class="fa-light fa-2x fa-arrow-left-long"></i>', '<i class="fa-light fa-2x fa-arrow-right-long"></i>'],
                                    responsive: {
                                        0: {
                                            items: 1
                                        },
                                        640: {
                                            items: 2
                                        },
                                        800: {
                                            items: 4
                                        },
                                        1281: {
                                            items: 5
                                        }
                                    }
                                });
                            });
                        }
                    })
                    .catch(error => console.error(error))
            },
            methods: {
                changelayoutmode: function() {
                    this.layoutMode = (this.layoutMode == 'map') ? '' : 'map';
                },
                callfilters: function(event) {
                    loadData = true;
                    // console.log(event);
                    let apiUrl = apidae.site_url + uri + '/json';
                    let query = '?searchByMap=0&zl=&slt=&slg=&nlt=&nlg=';

                    if (event.target.classList.contains('trifilterevent')) {
                        this.tri = [String(event.target.value)]
                    }
                    query += '&tri=' + this.tri[0];

                    if (event.target.classList.contains('pricevent')) {
                        this.pmin = Number(event.target.getAttribute('data-pmin'))
                        this.pmax = Number(event.target.getAttribute('data-pmax'))
                    }
                    query += '&pmin=' + this.pmin + '&pmax=' + this.pmax;

                    if (event.target.classList.contains('nombrejoursevent')) {
                        this.njmin = Number(event.target.getAttribute('data-njmin'))
                        this.njmax = Number(event.target.getAttribute('data-njmax'))
                    }
                    query += '&njmin=' + this.njmin + '&njmax=' + this.njmax;

                    if (showFiltreDate) {
                        query += '&rbl=calendar&dd=' + this.params.dateDebut + '&df=' + this.params.dateFin;
                    }

                    if (event.target.classList.contains('filterlibevent')) {
                        this.lib = String(event.target.value)
                    }
                    query += '&lib=' + this.lib

                    if (event.target.classList.contains('searchByGeo')) {
                        this.searchByGeo = Number(event.target.value)
                    }
                    if (event.target.classList.contains('searchByGeoRange')) {
                        this.searchByGeoRange = Number(event.target.value)
                    }
                    query += "&searchByGeo=" + this.searchByGeo + "&searchByGeoRange=" + this.searchByGeoRange;

                    // console.log(this.groupesFiltres);
                    let cgroupesFiltres = this.groupesFiltres;
                    cgroupesFiltres.forEach(cgroupefiltres => {
                        let cfiltres = cgroupefiltres.listeFiltre;
                        cfiltres.forEach(cfiltre => {
                            // console.log(cfiltre.selected);
                            if (cfiltre.selected) {
                                // console.log(cfiltre.idFiltre);
                                query += '&filter' + cfiltre.idFiltre + '=' + cgroupefiltres.idGroupe;
                            }
                        });
                    });
                    // console.log(cgroupesFiltres);
                    // console.log(query);

                    fetch(apiUrl + query)
                        .then(stream => stream.json())
                        .then(data => {
                            this.params = data.params;
                            this.groupesFiltres = data.filtres;
                            this.suggestions = data.items;
                            this.prestaItems = data.items.slice(0, nb);
                        })
                        .catch(error => console.error(error))
                        .finally(loadData = false)
                },
                callPaginate: function(url) {
                    this.loadPaginate = true
                    fetch(url)
                        .then(stream => stream.json())
                        .then(data => {
                            this.params = data.params;
                            this.groupesFiltres = data.filtres;
                            this.suggestions = data.items;
                            this.prestaItems = [...this.prestaItems, ...data.items.slice(0, nb)];
                        })
                        .catch(error => console.error(error))
                        .finally(this.loadPaginate = false)
                },
                // submitfilters: function(event) {
                //     let query =  uri + '?tri=triEvenement&searchByMap=0&zl=&slt=&slg=&nlt=&nlg=&njmin=0&njmax=8&pmin=' + this.pmin + '&pmax=' + this.pmax;
                //     let cgroupesFiltres = this.groupesFiltres;
                //     cgroupesFiltres.forEach(cgroupefiltres => {
                //         let cfiltres = cgroupefiltres.listeFiltre;
                //         cfiltres.forEach(cfiltre => {
                //             // console.log(cfiltre.selected);
                //             if (cfiltre.selected) {
                //                 console.log(cfiltre.idFiltre);
                //                 query += '&filter' + cfiltre.idFiltre + '=' + cgroupefiltres.idGroupe;
                //             }
                //         });
                //     });
                //     // console.log(apidae.site_url + uri);
                //     window.location = apidae.site_url + query;
                // }
            }
        });
    });
}